// extracted by mini-css-extract-plugin
export default {"dataTableFormat":"styles_dataTableFormat__6rX8s","formSpace":"styles_formSpace__IPzBO"};